import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    "nav.chapters": "How it works",
    "nav.practice": "How I Help",
    "nav.booking": "Booking",
    "nav.book": "Book Session",
    "nav.home": "Home",
    "brand.tagline": "— Counsellor",

    "hero.eyebrow": "A quiet counselling practice",
    "hero.l1": "Forty years",
    "hero.l2": "of listening.",
    "hero.l3": "A lifetime",
    "hero.l4": "of counsel.",
    "hero.tagline.prefix": "Today —",
    "hero.intro":
      "I am {NAME}, seventy-seven, retired from Jindal, and now offering something quieter — an hour of considered counsel for those tangled in family, legal, or financial troubles. Online or in person. From wherever you are.",
    "hero.book": "Book a session",
    "hero.read": "See how it works",
    "hero.stat1": "Years' service · Jindal",
    "hero.stat2": "Every session, personal",
    "hero.stat3": "Fields of counsel",
    "hero.scroll": "Scroll — the story unfolds",
    "hero.caption": "Hear, Help, Heal Together.",
    "hero.fig": "Fig. 001",
    "hero.practice": "Practice · No. I",
    "hero.est": "Est. 2025 · Delhi NCR",

    "howitworks.eyebrow": "§ How it works",
    "howitworks.title.a": "Four small steps, ",
    "howitworks.title.b": "one honest hour.",
    "howitworks.s1.title": "Pick a topic",
    "howitworks.s1.body": "Family, law, or finance — choose what weighs on you.",
    "howitworks.s2.title": "Choose a time",
    "howitworks.s2.body": "See the days I keep open and pick a slot that fits your afternoon.",
    "howitworks.s3.title": "Meet — online or in person",
    "howitworks.s3.body": "Meet me on this website (no downloads, works in your browser) or in person at Delhi NCR over tea.",
    "howitworks.s4.title": "Walk away clearer",
    "howitworks.s4.body": "Fifty minutes of unhurried listening — followed by a considered, plain-spoken second opinion.",
    "howitworks.badge": "No signup · Pay per session · Refunds within 24 hrs",

    "services.eyebrow": "§ How I Can Help",
    "services.title.a": "Three rooms, one chair, ",
    "services.title.b": "always occupied.",
    "services.s1.title": "Family & Relationships",
    "services.s1.body": "Difficult conversations that need a third, older, calmer chair in the room. Marriage, parenting, siblings, elder care.",
    "services.s2.title": "Legal Guidance",
    "services.s2.body": "Plain-English readings of contracts, wills, notices, property paperwork. Not a lawyer's opinion — an experienced one.",
    "services.s3.title": "Financial Sanity",
    "services.s3.body": "Retirement planning, pension paperwork, small-business books, family finance. The kind of talk you wish your uncle would give you.",

    "cta.eyebrow": "§ Booking",
    "cta.title.a": "One hour. ",
    "cta.title.b": "On the house of your choosing.",
    "cta.body":
      "Choose a topic, pick an afternoon, and I will meet you either across a table in Delhi NCR — or, if you prefer, right here on this website, no downloads needed.",
    "cta.begin": "Begin booking",
    "cta.write": "Or write a letter first",

    "footer.rights": "© 2025 · All rights, quietly reserved.",
    "footer.contact": "Contact",
    "footer.signin": "Practitioner sign-in",

    "marquee.words": "Listen • Consider • Counsel • Family • Law • Finance • A lifetime, offered •",

    "cta.eyebrow": "§ Booking",
    "cta.title.a": "One hour. ",
    "cta.title.b": "On the house of your choosing.",
    "cta.body":
      "Choose a topic, pick an afternoon, and I will meet you either across a table in Delhi NCR — or, if you prefer, right here on this website, no downloads needed.",
    "cta.begin": "Begin booking",
    "cta.write": "Or write a letter first",

    "footer.rights": "© 2025 · All rights, quietly reserved.",
    "footer.contact": "Contact",
    "footer.signin": "Practitioner sign-in",

    "book.eyebrow": "§ Booking · One session, ₹500",
    "book.title.a": "Reserve an ",
    "book.title.b": "hour",
    "book.sub": "Fifty minutes of unhurried counsel. Cancel any time before 24 hours — full refund, no questions.",
    "book.payment.title": "Payment",
    "book.payment.body": "Secured by Stripe. Test card:",
    "book.step1": "What weighs on you?",
    "book.step2": "How shall we meet?",
    "book.step3": "When?",
    "book.step4": "A little about you",
    "book.topic.family": "Family & Relationships",
    "book.topic.legal": "Legal Guidance",
    "book.topic.financial": "Financial Sanity",
    "book.mode.online": "On this website",
    "book.mode.online.sub": "Video meeting opens right in your browser",
    "book.mode.offline": "In person",
    "book.mode.offline.sub": "Address shared after confirmation",
    "book.slots.title": "Available times",
    "book.no.date": "Pick a date first.",
    "book.no.slots": "No slots on this day. Try another date.",
    "book.fullname": "Full name",
    "book.phone": "Phone",
    "book.email": "Email",
    "book.notes": "Notes (optional)",
    "book.total": "Total",
    "book.session": "· one session",
    "book.continue": "Continue to payment",
    "book.preparing": "Preparing…",
    "book.opt.a": "Option A",
    "book.opt.b": "Option B",
    "book.placeholder.name": "Your full name",
    "book.placeholder.phone": "+91 98xxxxxxxx",
    "book.placeholder.email": "you@example.com",
    "book.placeholder.notes": "A sentence or two about what you'd like to discuss.",
  },
  hi: {
    "nav.chapters": "कैसे काम करता है",
    "nav.practice": "मैं कैसे मदद करूँ",
    "nav.booking": "बुकिंग",
    "nav.book": "सत्र बुक करें",
    "nav.home": "मुख्य",
    "brand.tagline": "— सलाहकार",

    "hero.eyebrow": "एक शांत सलाह अभ्यास",
    "hero.l1": "चालीस वर्ष",
    "hero.l2": "सुनने के।",
    "hero.l3": "एक जीवन",
    "hero.l4": "सलाह का।",
    "hero.tagline.prefix": "आज —",
    "hero.intro":
      "मैं {NAME} हूँ, सतहत्तर वर्ष का, जिंदल से सेवानिवृत्त। अब मैं कुछ शांत सा प्रस्तुत करता हूँ — एक घंटे की सोची-समझी सलाह उनके लिए जो पारिवारिक, कानूनी या वित्तीय उलझनों में हैं। ऑनलाइन या रूबरू। जहाँ भी आप हों।",
    "hero.book": "सत्र बुक करें",
    "hero.read": "कैसे काम करता है, देखें",
    "hero.stat1": "वर्षों की सेवा · जिंदल",
    "hero.stat2": "हर सत्र, व्यक्तिगत",
    "hero.stat3": "सलाह के क्षेत्र",
    "hero.scroll": "स्क्रॉल करें — कहानी खुलती है",
    "hero.caption": "सुनें, मदद करें, मिलकर सँवारें।",
    "hero.fig": "चित्र 001",
    "hero.practice": "प्रैक्टिस · क्र. I",
    "hero.est": "स्था. 2025 · दिल्ली एनसीआर",

    "marquee.words": "सुनें • विचारें • मार्गदर्शन • परिवार • कानून • वित्त • जीवन भर की देन •",

    "howitworks.eyebrow": "§ यह कैसे काम करता है",
    "howitworks.title.a": "चार छोटे कदम, ",
    "howitworks.title.b": "एक ईमानदार घंटा।",
    "howitworks.s1.title": "विषय चुनें",
    "howitworks.s1.body": "परिवार, कानून या वित्त — जो भी मन पर भारी है, चुन लीजिए।",
    "howitworks.s2.title": "समय तय करें",
    "howitworks.s2.body": "मेरे खाली दिन देखिए और अपनी दोपहर के हिसाब से समय चुन लीजिए।",
    "howitworks.s3.title": "मिलिए — ऑनलाइन या रूबरू",
    "howitworks.s3.body": "इसी वेबसाइट पर मिलिए (कुछ डाउनलोड नहीं, ब्राउज़र में ही) या दिल्ली एनसीआर में चाय पर रूबरू।",
    "howitworks.s4.title": "स्पष्टता के साथ लौटिए",
    "howitworks.s4.body": "पचास मिनट की धैर्यपूर्ण सुनवाई — फिर एक सोची-समझी, सादगी से कही गई दूसरी राय।",
    "howitworks.badge": "साइनअप नहीं · प्रति सत्र भुगतान · 24 घंटे में रिफ़ंड",

    "services.eyebrow": "§ मैं कैसे मदद करूँ",
    "services.title.a": "तीन कक्ष, एक कुर्सी, ",
    "services.title.b": "सदा उपलब्ध।",
    "services.s1.title": "परिवार और रिश्ते",
    "services.s1.body": "कठिन बातचीत जिन्हें एक तीसरे, धीर, वृद्ध कान की ज़रूरत होती है। विवाह, पालन-पोषण, भाई-बहन, वृद्धजन देखभाल।",
    "services.s2.title": "कानूनी मार्गदर्शन",
    "services.s2.body": "अनुबंध, वसीयत, नोटिस, संपत्ति के कागज़ — सादी भाषा में। वकील की राय नहीं — अनुभव की।",
    "services.s3.title": "वित्तीय स्पष्टता",
    "services.s3.body": "सेवानिवृत्ति की योजना, पेंशन, छोटे व्यापार के हिसाब, पारिवारिक वित्त। वैसी सलाह जैसी आपके ताऊजी देते।",

    "cta.eyebrow": "§ बुकिंग",
    "cta.title.a": "एक घंटा। ",
    "cta.title.b": "आपके चुनाव के स्थान पर।",
    "cta.body": "विषय चुनिए, एक दोपहर तय कीजिए, और मैं मिलूँगा — दिल्ली एनसीआर में मेज़ के आर-पार, या यदि आप चाहें, तो इसी वेबसाइट पर, बिना कुछ डाउनलोड किए।",
    "cta.begin": "बुकिंग शुरू करें",
    "cta.write": "पहले एक पत्र लिखें",

    "footer.rights": "© 2025 · सर्वाधिकार सुरक्षित।",
    "footer.contact": "संपर्क",
    "footer.signin": "सलाहकार लॉगिन",

    "book.eyebrow": "§ बुकिंग · एक सत्र, ₹500",
    "book.title.a": "एक ",
    "book.title.b": "घंटा",
    "book.sub": "पचास मिनट की धैर्यपूर्ण सलाह। 24 घंटे पहले तक निःशुल्क रद्दीकरण — पूरा रिफ़ंड।",
    "book.payment.title": "भुगतान",
    "book.payment.body": "Stripe द्वारा सुरक्षित। टेस्ट कार्ड:",
    "book.step1": "क्या भार है मन पर?",
    "book.step2": "कैसे मिलेंगे?",
    "book.step3": "कब?",
    "book.step4": "थोड़ा सा आपके बारे में",
    "book.topic.family": "परिवार और रिश्ते",
    "book.topic.legal": "कानूनी मार्गदर्शन",
    "book.topic.financial": "वित्तीय स्पष्टता",
    "book.mode.online": "इसी वेबसाइट पर",
    "book.mode.online.sub": "वीडियो मीटिंग सीधे आपके ब्राउज़र में",
    "book.mode.offline": "रूबरू",
    "book.mode.offline.sub": "पुष्टि के बाद पता साझा किया जाएगा",
    "book.slots.title": "उपलब्ध समय",
    "book.no.date": "पहले तारीख़ चुनें।",
    "book.no.slots": "इस दिन कोई समय उपलब्ध नहीं। दूसरी तारीख़ आज़माएँ।",
    "book.fullname": "पूरा नाम",
    "book.phone": "फ़ोन",
    "book.email": "ईमेल",
    "book.notes": "टिप्पणी (वैकल्पिक)",
    "book.total": "कुल",
    "book.session": "· एक सत्र",
    "book.continue": "भुगतान पर जाएँ",
    "book.preparing": "तैयार हो रहा है…",
    "book.opt.a": "विकल्प क",
    "book.opt.b": "विकल्प ख",
    "book.placeholder.name": "आपका पूरा नाम",
    "book.placeholder.phone": "+91 98xxxxxxxx",
    "book.placeholder.email": "aap@example.com",
    "book.placeholder.notes": "एक-दो पंक्तियाँ जिसमें आप बात करना चाहते हैं।",
  },
};

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLangRaw] = useState(() => localStorage.getItem("lang") || "en");
  const setLang = (v) => {
    localStorage.setItem("lang", v);
    setLangRaw(v);
  };
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (k, params = {}) => {
    let s = dict[lang]?.[k] ?? dict.en[k] ?? k;
    Object.entries(params).forEach(([name, val]) => {
      s = s.replaceAll(`{${name}}`, val);
    });
    return s;
  };
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  return useContext(LangCtx);
}
